import React from 'react';
import styled, { keyframes } from 'styled-components';

// Animation: trượt sóng trái ↔ phải
const waveMove = keyframes`
  0% { transform: translateX(0%); }
  50% { transform: translateX(-25%); }
  100% { transform: translateX(0%); }
`;

// Wrapper giữ overflow hidden, thiết lập chiều cao và background gradient
const WaveWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 156px;
  overflow: hidden;
  background: linear-gradient(178deg, rgba(255,255,255,0) 22.94%, rgba(193,221,228,0.17) 52.29%, #0078A8 91.24%);

  svg {
    position: absolute;
    left: 0;
    width: 200%; /* gấp đôi để loop mượt */
    height: 100%;
    animation: ${waveMove} 10s ease-in-out infinite;
  }
`;

const Waves = () => (
  <WaveWrapper>
    {/* Sóng A */}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1432"
      height="156"
      viewBox="0 0 1432 156"
      style={{ top: 0, animationDelay: '0s', opacity: 0.7 }}
    >
      <path
        d="M584.82 142.878L0 21.5L1431.5 0L845.355 139.169C759.83 159.475 670.888 160.741 584.82 142.878Z"
        fill="url(#paint0_linear_1_1788)"
      />
      <defs>
        <linearGradient id="paint0_linear_1_1788" x1="748.122" y1="28.4244" x2="748.625" y2="142.088" gradientUnits="userSpaceOnUse">
          <stop stopColor="#006F80" stopOpacity="0" />
          <stop offset="0.518142" stopColor="#3FA5CF" stopOpacity="0.22" />
          <stop offset="1" stopColor="#12B3CC" />
        </linearGradient>
      </defs>
    </svg>

    {/* Sóng B */}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1432"
      height="156"
      viewBox="0 0 1432 156"
      style={{ top: 8, animationDelay: '3s', opacity: 0.85 }}
    >
      <path
        d="M584.82 142.878L0 21.5L1431.5 0L845.355 139.169C759.83 159.475 670.888 160.741 584.82 142.878Z"
        fill="url(#paint0_linear_1_1789)"
      />
      <defs>
        <linearGradient id="paint0_linear_1_1789" x1="748.122" y1="28.4244" x2="748.625" y2="142.088" gradientUnits="userSpaceOnUse">
          <stop stopColor="#006F80" stopOpacity="0" />
          <stop offset="0.518142" stopColor="#3FA5CF" stopOpacity="0.22" />
          <stop offset="1" stopColor="#12B3CC" />
        </linearGradient>
      </defs>
    </svg>

    {/* Sóng C */}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1432"
      height="156"
      viewBox="0 0 1432 156"
      style={{ top: 16, animationDelay: '6s', opacity: 1 }}
    >
      <path
        d="M584.82 142.878L0 21.5L1431.5 0L845.355 139.169C759.83 159.475 670.888 160.741 584.82 142.878Z"
        fill="url(#paint0_linear_1_1790)"
      />
      <defs>
        <linearGradient id="paint0_linear_1_1790" x1="748.122" y1="28.4244" x2="748.625" y2="142.088" gradientUnits="userSpaceOnUse">
          <stop stopColor="#006F80" stopOpacity="0" />
          <stop offset="0.518142" stopColor="#3FA5CF" stopOpacity="0.22" />
          <stop offset="1" stopColor="#12B3CC" />
        </linearGradient>
      </defs>
    </svg>
  </WaveWrapper>
);

export default Waves;